import { Box } from '@mui/material'
import { Colors } from '~/components/ui/color'
import { useMediaQuery } from '~/hooks/useMediaQuery'
import { AppFooterSocialLinks, AppFooterStoreBadges, AppFooterTextLinks } from './Content'

export const AppFooter = () => {
  const { isMd } = useMediaQuery()

  if (isMd) {
    return (
      <Box
        component='footer'
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '24px',
          height: '98px',
          px: '32px',
          backgroundColor: Colors['Base/Black'],
        }}
      >
        <Box display='flex' alignItems='center' gap='16px'>
          <AppFooterStoreBadges />
          <AppFooterTextLinks />
        </Box>
        <AppFooterSocialLinks />
      </Box>
    )
  }

  return (
    <Box
      component='footer'
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '16px',
        p: '32px',
        backgroundColor: Colors['Base/Black'],
      }}
    >
      <AppFooterStoreBadges />
      <AppFooterTextLinks />
      <AppFooterSocialLinks />
    </Box>
  )
}
